import React from "react";
import dynamic from "next/dynamic";
import revampData from "../../src/data/revampData.json";

const Marquee = dynamic(() => import("react-fast-marquee"), {
	ssr: false
});

interface Company {
	id: number | string;
	image: string[];
	description: string;
}

interface RevampDataShape {
	data: {
		listMarathonTrustedCompany: {
			data: Company[];
		};
	};
}

const companies: Company[] = (revampData as any).data.listMarathonTrustedCompany.data;

const CompanyCarousel: React.FC = () => {
	return (
		<div className="company-carousel-wrapper font-figtree">
			<div className="company-carousel">
				<Marquee
					speed={35}
					gradient={false}
					pauseOnHover={true}
					className="company-marquee"
				>
					{Array.isArray(companies[0]?.image) &&
						companies[0]?.image.map((img, index) => (
							<div key={index} className="company-item mx-3">
								<img
									src={img}
									alt={companies[0]?.description || "Marathon Partner"}
									className="company-image partner-logo"
								/>
							</div>
						))}
				</Marquee>
				<style jsx>{`
					.company-carousel-wrapper {
						position: relative;
						z-index: 1;
						padding: 2rem 0;
						background-color: #fff;
						margin-top: 2rem;
						margin-bottom: 2rem;
					}

					.company-carousel {
						max-width: 900px;
						width: 100%;
						margin: auto;
						position: relative;
					}

					.company-image {
						max-width: 150px;
						max-height: 90px;
						width: 100%;
						height: 100%;
						object-fit: contain;
					}

					.partner-logo {
						filter: grayscale(100%);
						transition: filter 0.3s ease;
					}

					.partner-logo:hover {
						filter: grayscale(0%);
					}

					:global(.company-marquee) {
						min-height: 100px;
						display: flex;
						align-items: center;
					}

					:global(.company-item) {
						display: flex;
						align-items: center;
						justify-content: center;
						height: 90px;
					}

					@media (max-width: 768px) {
						.company-carousel-wrapper {
							padding: 1rem 0;
							margin-top: 1rem;
							margin-bottom: 1rem;
						}

						.company-image {
							max-width: 120px;
							max-height: 70px;
						}

						:global(.company-marquee) {
							min-height: 80px;
						}

						:global(.company-item) {
							height: 70px;
						}
					}
				`}</style>
			</div>
		</div>
	);
};

export default CompanyCarousel;
